var e;!function(e){e.Next="NEXT",e.Prev="PREV"}(e||(e={}));export{e as CarouselDirectionType};
//# sourceMappingURL=Carousel.types.js.map
